import { api } from '@/lib/api'
import type { Configuration, ConfigurationRequest, ConfigurationUpdateRequest } from './types'

export async function listConfigurations(activeOnly = true): Promise<Configuration[]> {
  const r = await api.get<Configuration[]>('/api/configurations', { params: { activeOnly } })
  return r.data
}

export async function createConfiguration(payload: ConfigurationRequest): Promise<Configuration> {
  const r = await api.post<Configuration>('/api/configurations', payload)
  return r.data
}

export async function updateConfiguration(code: string, payload: ConfigurationUpdateRequest): Promise<Configuration> {
  const r = await api.put<Configuration>(`/api/configurations/${code}`, payload)
  return r.data
}

export async function deleteConfiguration(code: string): Promise<void> {
  await api.delete(`/api/configurations/${code}`)
}

export async function setConfigurationSections(configurationCode: string, ids: number[]): Promise<void> {
  await api.put(`/api/forms/configuration/${configurationCode}/sections`, { ids })
}

export async function setConfigurationStatusTracks(configurationCode: string, ids: number[]): Promise<void> {
  await api.put(`/api/status-tracks/configuration/${configurationCode}`, { ids })
}
